import PropTypes from "prop-types";
import { GraduationCap } from "lucide-react";

const classOfDegreeMap = {
  first_class: "First Class",
  second_class_upper: "Second Class Upper",
  second_class_lower: "Second Class Lower",
  distinction: "Distinction",
  upper_credit: "Upper Credit",
  lower_credit: "Lower Credit",
};

const ReportField = ({ label, value }) => (
  <div className="flex flex-col border-b border-slate-100 pb-2 last:border-0 last:pb-0">
    <span className="text-[10px] text-slate-400 uppercase font-bold tracking-wider mb-1">
      {label}
    </span>
    <span className="text-sm font-medium text-slate-600">{value || "N/A"}</span>
  </div>
);

function AcademicDetails({ details }) {
  if (!details || typeof details !== "object") {
    return (
      <div className="p-4 text-sm text-slate-500 text-center border border-dashed rounded-lg">
        No academic details available
      </div>
    );
  }

  const academicDetails = [
    { label: "Name of School", value: details.institution?.name },
    { label: "Course of Study", value: details.course?.name },
    { label: "Year of Graduation", value: details.graduation_year },
    { label: "NYSC Certificate Number", value: details.certificate_number },
    { label: "NYSC Call Up Number", value: details.call_up_number },
    {
      label: "Grade",
      value:
        classOfDegreeMap[details.graduating_class] || details.graduating_class,
    },
  ];

  return (
    <div className="bg-white rounded-xl  border border-slate-200 overflow-hidden w-full">
      <div className="bg-slate-50 px-6 py-3 border-b border-slate-100 flex items-center gap-2">
        <GraduationCap size={16} className="text-slate-500" />
        <h2 className="text-xs font-bold text-slate-700 uppercase tracking-wider">
          Academic Details
        </h2>
      </div>
      <div className="p-6 grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-6">
        {academicDetails.map((detail, index) => (
          <ReportField key={index} label={detail.label} value={detail.value} />
        ))}
      </div>
    </div>
  );
}

AcademicDetails.propTypes = {
  details: PropTypes.shape({
    institution: PropTypes.shape({
      name: PropTypes.string,
    }),
    course: PropTypes.shape({
      name: PropTypes.string,
    }),
    graduation_year: PropTypes.string,
    certificate_number: PropTypes.string,
    call_up_number: PropTypes.string,
    graduating_class: PropTypes.string,
  }),
};

export default AcademicDetails;
